import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { ProjectFilterKeys } from '../../../../shared/organizationPackages';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import { CheckboxFilterGroup } from '../../generic/Filter';
import type { AnyFilter, BlockType } from '../../../../shared/organizationPackages';

const BLOCK_TYPE_OPTIONS = [
  { key: 'has_blocked_packages', label: 'Uses blocked package(s)' },
  { key: 'no_blocked_packages', label: 'No blocked package(s)' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageBlockType displays two checkboxes to let users filter by block type (blocked packages or non-blocked packages).
 */
const PackageBlockType: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const blockTypes = useSelector(PackageInventoryStore.selectors.getBlockTypeFilters);
  //  Returns an onChange handler for our inputs
  const onSelect = (blockType: BlockType, isChecked: boolean) => {
    if (isChecked) {
      setFilters({ [ProjectFilterKeys.BlockTypes]: [...blockTypes, blockType] });
    } else {
      setFilters({ [ProjectFilterKeys.BlockTypes]: blockTypes.filter(d => d !== blockType) });
    }
  };
  return (
    <CheckboxFilterGroup
      title="Blocked"
      options={BLOCK_TYPE_OPTIONS}
      selectedOptions={blockTypes}
      onSelect={onSelect as (key: string, isChecked: boolean) => void}
      testId="package-inventory-filters--block-type"
    />
  );
};

export default PackageBlockType;
